import { render } from "./Management.vue?vue&type=template&id=7ce24bba&scoped=true&ts=true"
import script from "./Management.vue?vue&type=script&lang=ts"
export * from "./Management.vue?vue&type=script&lang=ts"

import "./Management.vue?vue&type=style&index=0&id=7ce24bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce24bba"]])

export default __exports__